import React from 'react'
import "./CardTransactionDocumentsData.css"
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../redux/store/store'

const CardTransactionDocumentsData = () => {

    const Tax_Information = useSelector((state: RootState) => state.transactionReports.Tax_Information)

    return (
        <div className="card-transaction-documents-report center ml-8 border-radius-6">
            <div className="center flex-d-column">
                <img src="../assets/svg/tax_data.svg" alt="tax data" />
                <p className="fs-12 color-text mt-10">Tax data{Tax_Information ? " OK" : " NOT OK"}</p>
            </div>
        </div>
    )
}

export default React.memo( CardTransactionDocumentsData )